import { AudioHTMLAttributes } from 'react';
import Asset from '@/components/asset';

export default function Audio(props: AudioHTMLAttributes<HTMLAudioElement>) {
    return <Asset element={'audio'} {...props} />;
}
